import type { FC } from "react";

import type { IconName, IconSize } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import type { ButtonType } from "@similarweb/ui-components";
import { Tooltip } from "@similarweb/ui-components";

import { StyledBaseCell, StyledSocialNetworkIconButton } from "./styles";

interface SocialLinkCellProps {
    /** The URL to link to */
    url?: string;
    /** Icon name for the button */
    iconName: IconName;
    /** Tooltip text content */
    tooltipText: string;
    /** Data automation attribute */
    dataAutomation?: string;
    /** Optional click handler for tracking */
    onLinkClick?: () => void;
    /** CSS class name */
    className?: string;
    /** Button type */
    buttonType?: ButtonType;
    /** Icon size */
    iconSize?: IconSize;
    /** Icon color */
    iconColor?: string;
    /** Is centered */
    isCentered?: boolean;
}

const SocialLinkCell: FC<SocialLinkCellProps> = ({
    url,
    iconName,
    tooltipText,
    dataAutomation,
    onLinkClick,
    className = "",
    buttonType = "flat",
    iconSize = "xs",
    iconColor = colorsPalettes.blue[400],
    isCentered = false,
}) => (
    <StyledBaseCell isCentered={isCentered}>
        {url ? (
            <Tooltip content={tooltipText}>
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={onLinkClick}
                >
                    <StyledSocialNetworkIconButton
                        className={className}
                        type={buttonType}
                        iconName={iconName}
                        iconSize={iconSize}
                        dataAutomation={dataAutomation}
                        iconColor={iconColor}
                    />
                </a>
            </Tooltip>
        ) : null}
    </StyledBaseCell>
);

export default SocialLinkCell;
